import React, { useEffect, useState } from 'react';
import {
    Card,
    FormLayout,
    TextField,
    BlockStack,
    InlineGrid,
    Box,
    Text,
    Layout,
    Select
} from '@shopify/polaris';
import { useDispatch, useSelector } from 'react-redux';
import { getAllSetting } from '../../redux/setting/slice';
import { getFormulaAsync } from '../../redux/setting/index';
import LoadingComponent from '../common/Loading';
import { METAL_TYPES, FORMULA_VARIABLES_HELP_TEXT } from '../../utils/json';

const PricingFormula = () => {
    const dispatch = useDispatch();
    const { formulaData, isFormulaLoading } = useSelector(getAllSetting);
    const [metalType, setMetalType] = useState('gold');
    const [formula, setFormula] = useState('');

    useEffect(() => {
        dispatch(getFormulaAsync());
    }, [dispatch]);

    useEffect(() => {
        if (formulaData && formulaData.length > 0) {
            setFormula(formulaData.find(item => item.metalType === metalType)?.formula || '');
        }
    }, [metalType, formulaData]);

    const handleMetalTypeChange = (value) => {
        setMetalType(value);
    };

    if (isFormulaLoading) {
        return <LoadingComponent />;
    }

    return (
        <Layout.Section>
            <BlockStack gap={{ xs: "800", sm: "400" }}>
                <InlineGrid columns={{ xs: "1fr", md: "2fr 5fr" }} gap="400">
                    <Box
                        as="section"
                        paddingInlineStart={{ xs: 400, sm: 0 }}
                        paddingInlineEnd={{ xs: 400, sm: 0 }}
                    >
                        <BlockStack gap="400">
                            <Text as="h3" variant="headingMd">
                                Price Formula Configuration
                            </Text>
                            <Text as="p" variant="bodyMd">
                                This section shows how your product price is calculated using the current gold rate and custom markup settings.
                            </Text>
                        </BlockStack>
                    </Box>
                    <Card roundedAbove="sm">
                        <FormLayout>
                            <Select
                                label="Metal Type"
                                options={METAL_TYPES}
                                onChange={(value) => handleMetalTypeChange(value)}
                                value={metalType}
                                helpText="Supported metal types are Gold."
                                readOnly
                            />
                            <TextField
                                label={`Default Formula Logic for ${metalType}`}
                                value={formula}
                                onChange={(value) => setFormula(value)}
                                multiline={2}
                                autoComplete="off"
                                helpText={FORMULA_VARIABLES_HELP_TEXT}
                                readOnly
                            />
                        </FormLayout>
                    </Card>
                </InlineGrid>
            </BlockStack>
        </Layout.Section>
    );
};

export default PricingFormula;
